import styles from '../Styles/Button.module.css';

const WhatsAppIcon = () => (
  <svg
    width="20" height="20" viewBox="0 0 24 24"
    fill="currentColor" aria-hidden="true"
    style={{ position: 'relative', zIndex: 1 }}
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.12.554 4.112 1.523 5.843L.057 23.571l5.91-1.49A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.837 0-3.564-.476-5.07-1.31l-.363-.213-3.508.884.925-3.41-.235-.376A9.956 9.956 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
  </svg>
);

const Button = ({ children, onClick, variant = 'primary', icon = 'whatsapp', className = '' }) => {
  return (
    <button
      className={`${styles.button} ${styles[variant]} ${className}`}
      onClick={onClick}
    >
      {/* En variante whatsapp usamos el SVG interno;
          en el resto respetamos la prop icon original */}
      {variant === 'whatsapp' ? (
        <WhatsAppIcon />
      ) : (
        icon === 'whatsapp' && (
          <span className={styles.icon}>
            <WhatsAppIcon />
          </span>
        )
      )}
      <span style={{ position: 'relative', zIndex: 1 }}>{children}</span>
    </button>
  );
};

export default Button;